
export type GetDashboardStatistics200Statistics = {
  activeUsers?: number;
  period?: string;
  totalRevenue?: number;
  totalSubscriptions?: number;
};
